import React from 'react';

interface ActionLinkProps {
  label: string;
  available: boolean;
  onClick: () => void;
  loading?: boolean;
}

export const ActionLink: React.FC<ActionLinkProps> = ({
  label,
  available,
  onClick,
  loading = false,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (available && !loading) {
      onClick();
    }
  };

  return (
    <span
      onClick={handleClick}
      style={{
        color: available ? '#0066cc' : '#999',
        cursor: available ? (loading ? 'wait' : 'pointer') : 'not-allowed',
        textDecoration: 'none',
        fontSize: '14px',
      }}
      onMouseEnter={(e) => {
        if (!available) {
          e.currentTarget.style.cursor = 'not-allowed';
        }
      }}
    >
      {loading ? 'Loading...' : label}
    </span>
  );
};
